import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * ThinkingPanel — AI 思考过程折叠面板
 *
 * 展示 AI Agent 对话中的思考（reasoning/thinking）过程：
 *   - 思考进行中：展开状态，显示 ThinkingIcon + "思考中" + 流式文本
 *   - 思考结束后：自动折叠，显示 ThinkingIcon + "已完成思考" + 展开/折叠箭头
 *   - 用户可点击箭头手动展开/折叠查看思考内容
 *
 * 复用已有的 AiReasoningStatusBlock 组件作为状态头部，
 * 复用 AiDrawer.scss 中的 reasoningContent 样式。
 *
 * 被 AiChatBotEx（AI Agent 模式）使用，渲染 THINKING_TEXT_MESSAGE_* 事件的内容。
 */
import { useState, useEffect } from 'react';
// @ts-ignore - JS component
import AiReasoningStatusBlock from 'components/top/AiDrawer/AiReasoningStatusBlock';
// @ts-ignore - SCSS module
import scss from './AiDrawer.scss';
const ThinkingPanel = ({ thinking }) => {
    const [collapsed, setCollapsed] = useState(false);
    // 思考结束时自动折叠，思考开始时自动展开
    useEffect(() => {
        if (thinking.isStreaming) {
            setCollapsed(false);
        }
        else {
            setCollapsed(true);
        }
    }, [thinking.isStreaming]);
    return (_jsxs("div", { className: scss.clawThinkingPanel, children: [_jsx(AiReasoningStatusBlock, { isReasoning: thinking.isStreaming, isCollapsed: collapsed, onChangeCollapsed: (v) => setCollapsed(v) }), !collapsed && thinking.text && (_jsx("pre", { className: scss.reasoningContent, children: _jsx("div", { children: thinking.text }) }))] }));
};
export default ThinkingPanel;
